import { DeleteOutlined, EnvironmentTwoTone } from '@ant-design/icons';
import { Card, Checkbox, Space } from 'antd';
import React from 'react';

const BoxInfoCard = ({ data, index, insureHandler, dimensions, weight, logistictype, deleteIcon = false, parentBoxId = '' }) => {
    const SelfLogisticTypeCard = () => {
        return (
            <Card
                style={{
                    padding: '10px',
                }}
            >
                <span
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    {' '}
                    {deleteIcon && <DeleteOutlined onClick={deleteIcon} />}
                </span>
                <div className="address_card_header">
                    <span>
                        <b>TrackingNumber: </b>
                        {data.trackingNumber}
                    </span>
                </div>
                <div>
                    <span>
                        <b>ReferenceNumber: </b>
                        {data.referenceNumber}
                    </span>
                </div>
                {data?.src && (
                    <div>
                        <span>
                            <b>From Address: </b>
                            {`${data?.src?.addressLine1}, ${data?.src?.addressLine2}, ${data?.src?.city}, ${data?.src?.stateOrProvince}, ${data?.src?.country}`}
                        </span>
                    </div>
                )}
            </Card>
        );
    };

    const ThirdPartyLogisticTypeCard = () => {
        return (
            <Card
                style={{
                    padding: '10px',
                    boxShadow: '0px 0px 10px -9px black',
                }}
            >
                <span
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    {deleteIcon && <DeleteOutlined onClick={deleteIcon} />}
                </span>
                <div className="address_card_header">
                    <div>
                        <ul>
                            <li style={{ listStyleType: 'none' }}>
                                <b>{!!parentBoxId ? 'To' : 'From'}: </b>
                            </li>
                        </ul>
                        <div>
                            {' '}
                            <EnvironmentTwoTone twoToneColor="black" />{' '}
                            {`${data?.src?.addressLine1}, ${data?.src?.addressLine2 ? data?.src?.addressLine2 + ',' : ''} ${data?.src?.city}, ${data?.src?.stateOrProvince}, ${data?.src?.country}`}
                        </div>
                    </div>
                </div>
                <div className="address_card_body w-100">
                    <div>
                        <ul>
                            <li style={{ listStyleType: 'none' }}>
                                <b>Dimensions </b>({`${dimensions?.length} x ${dimensions?.width} x ${dimensions?.height}`})<b>&nbsp;: </b>
                            </li>
                        </ul>
                    </div>
                    <div
                        style={{
                            paddingLeft: '2rem',
                        }}
                    >
                        <ul>
                            {dimensions?.length && (
                                <li>
                                    {' '}
                                    <b>Length: </b>
                                    {dimensions?.length}
                                </li>
                            )}
                            {dimensions?.width && (
                                <li>
                                    {' '}
                                    <b>Width: </b>
                                    {dimensions?.width}
                                </li>
                            )}
                            {dimensions?.height && (
                                <li>
                                    {' '}
                                    <b>Height: </b>
                                    {dimensions?.height}
                                </li>
                            )}
                            {weight && (
                                <li>
                                    {' '}
                                    <b>Weight: </b>
                                    {weight} pounds
                                </li>
                            )}
                        </ul>
                    </div>
                    <div className="address_card_footer">
                        <div>
                            <span style={{ display: 'flex', gap: '1.5rem' }}>
                                <span>
                                    <strong>Insured: </strong>
                                    <Checkbox checked={data?.insurance?.isInsured} onChange={e => insureHandler(e.target, index)} />
                                </span>
                                <Space size="large"></Space>
                                <span>
                                    <strong> Insurance Amount: </strong>
                                    <span>
                                        {data?.insurance?.insuranceAmount} {data?.insurance?.insuranceCurrency}
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div>
                        <span>
                            <strong>Tentative Pickup slot: </strong> 09-Jan-2023 10:00 AM - 07:00 PM
                        </span>
                    </div>
                    {data.trackingNumber && (
                        <div>
                            <div>
                                <b>TrackingNumber: </b>
                                {data?.trackingNumber}
                            </div>
                            <div>
                                <b>Reference Number: </b>
                                {data?.referenceNumber}
                            </div>
                        </div>
                    )}
                </div>
            </Card>
        );
    };

    function logisticTypeCard() {
        switch (logistictype) {
            case 'self':
                return <SelfLogisticTypeCard />;
            case 'flixstock':
                return <ThirdPartyLogisticTypeCard />;

            default:
                return <SelfLogisticTypeCard />;
        }
    }
    return <div>{logisticTypeCard()}</div>;
};

export default BoxInfoCard;
